import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ProtectedImage } from "@/components/ProtectedImage";

export function ZoomableImage({ src, alt = "", className = "", testid }) {
  const [open, setOpen] = useState(false);
  if (!src) return null;
  return (
    <>
      <ProtectedImage
        src={src}
        alt={alt}
        data-testid={testid}
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        className={`${className} cursor-zoom-in`}
      />
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          className="bg-slate-950/95 border-slate-700 p-3 max-w-4xl w-auto"
          onClick={(e) => e.stopPropagation()}
          aria-describedby={undefined}
          data-testid="image-zoom-dialog"
        >
          <DialogTitle className="sr-only">Imagem ampliada</DialogTitle>
          <ProtectedImage src={src} alt={alt} data-testid="image-zoom-full" className="mx-auto max-h-[80vh] w-auto max-w-full object-contain rounded" />
        </DialogContent>
      </Dialog>
    </>
  );
}
